// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'

import { string } from 'yup';


const obj =  {
	field:[
		
        { 
			title: "Website Content", 
			attr: "content",  
			value: "", 
			id:"websiteContent",
			placeholder: "Website content", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Website Content is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
	
        { 
			title: "Website Content", 
			attr: "content",  
			value: "Play games in easy mode gaming is meant for relaxing not to stress your self", 
			id:"websiteContent",
			placeholder: "Website content", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Website Content is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output: `Playing games on easy move on great a way to relax and have fun without feeling overwhelmed.`
		// Playing games on easy mode is a great way to relax and de-stress.Easy mode gaming can be an enjoyable way to unwind and take your mind off things.

	}
	}
	
	
	export default obj
	
	